import firebase from '@/firebase/firebase'
import { httpsCallable } from "@/firebase/functions";

const db = firebase.firestore()

function randomId() {
    return (new Date()).getTime().toString(36) + Math.random().toString(36).slice(2);
}

export default {
    namespaced : true,

    state : {
        commitedPayments: [],
        tempPayments: [],
        discount : {
            absolute: {
                value : 0
            }
        },
        taxes: {
            enabled: false
        },
        nfce: {
            enabled: false,
            cpf: '',
            name: '',
            print: true
        },
        untrackSnapshot: null
    },

    getters: {
        payments: (state) => [ ...state.tempPayments, ...state.commitedPayments ],
        totalPaidInPayments: (state, getters) => getters.payments.reduce((prev, curr) => prev + curr.value, 0),
        totalTempValue: (state) => state.tempPayments.reduce((prev, curr) => prev + curr.value, 0)
    },

    actions : {

        async commitPayments ({ state, rootGetters, commit }, { billId, table, client, userOrders }) {
            const companyId  = rootGetters.getCompanyID;
            const setOrdersAsPaid = httpsCallable('setOrdersAsPaid');

            this.commit('bill/setBusyTable', { billId, status: true });
            try {
                const { tempPayments, taxes, discount } = state;
    
                var calculatedTaxes = tempPayments.reduce((prev, curr) => prev + curr.value, 0);

                await setOrdersAsPaid({
                    companyId,
                    billId,
                    methods: tempPayments,
                    client: client || {},
                    userOrders,
                    taxes: taxes.enabled ? { percentage: { value: calculatedTaxes / 10 } }: {},
                    discount
                });
                commit('resetPaymentState');
                this.commit('bill/alertSuccessNotify', { table });
            } catch (err) {
                this.commit('setError', err);
                this.commit('bill/alertErrorNotify', { table });
            } finally {
                this.commit('bill/setBusyTable', { billId, status: false });
            }
        },

        openPaymentSnapshot ({ commit, rootGetters }, { billId }) {
            const companyId  = rootGetters.getCompanyID
            const paymentsRef = db.collection('payments')
                .where('billId', '==', billId)
                .where('companyId', '==', companyId)
                .where('confirmed', '==', true);

            const paymentSnapshotRef = paymentsRef
                .onSnapshot(snapshot => {
                    snapshot.docChanges().forEach(change => {
                        const payment = { id: change.doc.id, ...change.doc.data() };
                        if(change.type === "added")
                            commit('addPayment', payment);
                        else if(change.type === "modified") {
                            commit('removePayment', payment);
                            commit('addPayment', payment);
                        } else
                            commit('removePayment', payment);
                    });
                });
            commit('disposeSnapshot');
            commit('setSnapshotRef', paymentSnapshotRef);
        },
    },

    mutations : {
        addTempPayment (state, payment) {
            state.tempPayments.push({ id: randomId() ,...payment });
        },
        resetPaymentState (state) {
            state.tempPayments = [];
            state.discount.absolute.value = 0;
            state.nfce.name = '';
            state.nfce.cpf = '';
        },
        addPayment (state, payment) {
            state.commitedPayments.push(payment);
        },
        removePayment (state, payment) {
            state.commitedPayments = state.commitedPayments.filter(p => p.id !== payment.id);
        },
        setSnapshotRef (state, snapRef) {
            state.untrackSnapshot = snapRef;
        },
        disposeSnapshot (state) {
            if (state.untrackSnapshot)
                state.untrackSnapshot();
            state.commitedPayments = [];
        },
        removeTempPayment (state, index) {
            state.tempPayments = state.tempPayments.filter((_, i) => i !== index);
        },
        changeTemPaymentType (state, { index, type }) {
            state.tempPayments[index].type = type;
        },
        togglePayingTaxes (state, value) {
            state.taxes.enabled = value;
        },
        setDiscountValue (state, value) {
            console.log('setted', value);
            state.discount.absolute.value = value;
        },
        setNfce (state, nfce) {
            state.nfce = nfce;
        }
    }
}